var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcDwn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_dwn",
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 60,
    viewBox: "0 0 70 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "files-folder-svgrepo-com"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4208",
    "data-name": "\\uD328\\uC2A4 4208",
    d: "M0,144.516v32.746a3.162,3.162,0,0,0,3.161,3.275h54.8a3.162,3.162,0,0,0,3.161-3.275V144.516a3.162,3.162,0,0,0-3.161-3.275H3.161A3.229,3.229,0,0,0,0,144.516",
    transform: "translate(0 -130.536)",
    fill: "#fbc176"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4209",
    "data-name": "\\uD328\\uC2A4 4209",
    d: "M79.04,63.67a4.256,4.256,0,0,0-4.2-4.282H58.017l-5.256-6.423H29.636a3.192,3.192,0,0,0-3.153,3.211V63.67Z",
    transform: "translate(-23.272 -52.965)",
    fill: "#c39a6e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2427",
    "data-name": "\\uADF8\\uB8F9 2427",
    transform: "translate(5.352 16.341)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4210",
    "data-name": "\\uD328\\uC2A4 4210",
    d: "M58.054,187.519H45.209a1.071,1.071,0,0,1,0-2.141H58.054a1.071,1.071,0,1,1,0,2.141",
    transform: "translate(-44.138 -185.378)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4211",
    "data-name": "\\uD328\\uC2A4 4211",
    d: "M58.054,222.83H45.209a1.071,1.071,0,0,1,0-2.141H58.054a1.071,1.071,0,0,1,0,2.141",
    transform: "translate(-44.138 -216.407)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2431",
    "data-name": "\\uADF8\\uB8F9 2431",
    transform: "translate(40 30)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_480",
    "data-name": "\\uD0C0\\uC6D0 480",
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#5289c9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "down-arrow-svgrepo-com",
    transform: "translate(8 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2430",
    "data-name": "\\uADF8\\uB8F9 2430"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4212",
    "data-name": "\\uD328\\uC2A4 4212",
    d: "M7.961,16.164a.565.565,0,0,0,.85.05c.6-.6,6.125-6.307,6.125-6.307s.765-.761-.249-.761h-2.63V.363S12.069,0,11.6,0H5.136c-.657,0-.543.434-.543.434V9.328H1.745c-.834,0-.066.726-.066.726Z",
    transform: "translate(-1.357 0)",
    fill: "#f7f5e6"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDwn);
export default __webpack_public_path__ + "static/media/ic_dwn.216c09c134d1818be480ac368ac0b563.svg";
export { ForwardRef as ReactComponent };